import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useFixedExpenseData} from "../../hooks/useFixedExpenseData";
import {getDataFresh, getDepartmentsData, getFixedExpensesData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import {Box, Columns, Heading, Pagination, Table} from "react-bulma-components";
import NewFixedExpense from "./NewFixedExpense";
import axios from "axios";
import {createSetDataFreshAction, createSetFixedExpenseDataAction} from "../../actions/dataActions";
import {NotificationManager} from "react-notifications";
import FixedExpenseRow from "./FixedExpenseRow";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";





export default function FixedExpense(props){
    const [page, setPage] = useState(1);
    const [selectedDepartment, setSelectedDepartment] = useState();
    const [filters, setFilters] = useState({});
    const dispatch = useDispatch();
    const dataFresh = useSelector(getDataFresh);



    const headings = [
        {
            label: "Department",
            field: "department",
            labelField: "department__name"
        },
        {
            label: "Supplier",
            field: "supplier",
            labelField: "supplier__display_name"
        },
        {
            label: "Description"
        },
        {
            label: "Start Date"
        },
        {
            label: "Renewal Date"
        },
        {
            label: "Yearly Amount"
        },
        {
            label: ""
        }
    ]

    let params = {page, page_size:25}

    if(selectedDepartment){
        params.department = selectedDepartment;
    }

    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }

    let dataLoaded = useFixedExpenseData(params, dataFresh);
    let departmentsLoaded = useDepartmentsData({}, dataFresh);

    let data = useSelector(getFixedExpensesData);
    let departments = useSelector(getDepartmentsData);

    if(!dataLoaded || !departmentsLoaded){
        return (<LoadingSpinner/>)
    }
    const departmentObjects = departments.results.reduce((obj, item) => {
        return {
            ...obj,
            [item["id"]]: item
        };
    }, {});





    const onSave = (data) => {
        let additionalUrl = data.id ? 'fixedexpense/'+data.id : 'fixedexpense'
        const url = props.endpoint+additionalUrl;
        const conf = {
            url,
            method: data.id ? "put" : "post",
            data
        };

        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            setPage(1);
        }).catch(err => {
            NotificationManager.error("There was an error saving");
        });
    };

    const onDelete = (data) => {
        const conf = {
            url: props.endpoint+"fixedexpense/"+data.id,
            method: "delete"
        }
        axios(conf).then(res => {
            setPage(1);
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            NotificationManager.error("There was an error deleting");
        });
    };

    const onChange = (e, index) => {
        let newState = {...data};
        newState.results[index][e.target.name] = e.target.value;
        dispatch(createSetFixedExpenseDataAction(newState));
    }

    const onDepartmentChange = e => {
        setSelectedDepartment(e.target.value);
    }

    return (
        <dix>
            <NewFixedExpense onSave={onSave} departments={departments} departmentObjects={departmentObjects}/>
            <Box>
                <Heading>Fixed Expenses</Heading>
                <Columns>
                    <Columns.Column>
                        <DepartmentPicker
                            selectedDepartment={selectedDepartment}
                            departments={departments}
                            onDepartmentChange={onDepartmentChange}
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"}>
                            <thead>
                                <tr>
                                    {headings.map(heading => {
                                        if (!heading.field) {
                                          return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                                        }
                                        if (heading.blank) {
                                          return (
                                            <FilterBlankHeading
                                              key={heading.label}
                                              heading={heading}
                                              setFilters={f => {
                                                setPage(1);
                                                setFilters(f);
                                              }}
                                              filters={filters}
                                              className={heading.className}
                                              thClass={heading.thClass}
                                            />
                                          );
                                        }
                                        return (
                                          <FilterHeading
                                            key={heading.label}
                                            heading={heading}
                                            setFilters={f => {
                                              setPage(1);
                                              setFilters(f);
                                            }}
                                            filters={filters}
                                            options={data.filter_list[heading.field]}
                                            className={heading.className}
                                            thClass={heading.thClass}
                                          />
                                        );
                                      })}
                                </tr>
                            </thead>
                            <tbody>
                            {data.results.map((fixedExpense, index) => (
                                <FixedExpenseRow
                                    fixedExpense={fixedExpense}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onDelete={onDelete}
                                    index={index}
                                    departments={departments}
                                    departmentObjects={departmentObjects}
                                />
                            ))}
                            </tbody>
                        </Table>
                        <Pagination
                          showFirstLast={true}
                          onChange={setPage}
                          current={page}
                          total={Math.ceil(data ? data.count / 25 : 0)}
                        ></Pagination>
                    </Columns.Column>
                </Columns>
            </Box>
        </dix>
    )


}